import styled from 'styled-components';

import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {MuiFormLabelFilledColorByCurrentApp} from '../../../../../utils/get-app-env'

export const StyledTextField = styled(TextField)`
  max-width: 20rem;
  width: 100%;

  && {
    margin: 2rem 0;
  }
`;

export const StyledAutoComplete = styled(Autocomplete) <{ $gridArea?: string }>`
  max-width: 14rem;
  width: 100%;
  grid-area: ${props => props.$gridArea};

  & .MuiInputBase-input {
    color: ${(MuiFormLabelFilledColorByCurrentApp())};
  }
  
  & .MuiFormLabel-root {
    /* color: red */

  }
`;